import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const KEY = "omnibat_client_install_dismissed";
let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isMobile = () => /android|iphone|ipad|ipod/i.test(navigator.userAgent);

export default function InstallBanner() {
  const [show, setShow] = useState(false);
  const [canPrompt, setCanPrompt] = useState(!!deferred);
  useEffect(() => {
    if (isStandalone() || !isMobile() || localStorage.getItem(KEY)) return;
    setShow(true);
    const h = (e) => { e.preventDefault(); deferred = e; setCanPrompt(true); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  if (!show) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const install = async () => { deferred.prompt(); await deferred.userChoice; deferred = null; close(); };
  return (
    <div className="fixed bottom-4 inset-x-4 z-50 rounded-2xl bg-white border shadow-xl p-4 flex items-start gap-3 animate-in slide-in-from-bottom-4" data-testid="portal-install-banner">
      <img src="/logo-omnibat-icon.png" alt="" className="h-11 w-11 rounded-xl border p-1" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm">Installer l'espace client</p>
        {canPrompt ? <p className="text-xs text-slate-500 mt-0.5">Accédez à votre chantier en un geste depuis l'écran d'accueil.</p>
          : isIOS() ? <p className="text-xs text-slate-500 mt-0.5" data-testid="portal-install-ios">Touchez <Share className="inline h-3.5 w-3.5 mx-0.5" /> Partager, puis « Sur l'écran d'accueil ».</p>
          : <p className="text-xs text-slate-500 mt-0.5">Ouvrez le menu du navigateur, puis « Ajouter à l'écran d'accueil ».</p>}
        {canPrompt && <button onClick={install} className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-[#076633] text-white text-xs font-semibold px-4 py-2" data-testid="portal-install-btn"><Download className="h-3.5 w-3.5" />Installer</button>}
      </div>
      <button onClick={close} className="p-1 text-slate-400" data-testid="portal-install-close"><X className="h-4 w-4" /></button>
    </div>
  );
}
